var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltipDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1112,36 C1116.411,36 1120,39.589 1120,44 C1120,48.411 1116.411,52 1112,52 C1107.589,52 1104,48.411 1104,44 C1104,39.589 1107.589,36 1112,36 Z M1112,37 C1108.14,37 1105,40.14 1105,44 C1105,47.86 1108.14,51 1112,51 C1115.86,51 1119,47.86 1119,44 C1119,40.14 1115.86,37 1112,37 Z M1112,42 C1112.276,42 1112.5,42.224 1112.5,42.5 L1112.5,47.4983431 C1112.5,47.7748431 1112.276,47.9983431 1112,47.9983431 C1111.724,47.9983431 1111.5,47.7748431 1111.5,47.4983431 L1111.5,42.5 C1111.5,42.224 1111.724,42 1112,42 Z M1112,40 C1112.27614,40 1112.5,40.2238576 1112.5,40.5 C1112.5,40.7761424 1112.27614,41 1112,41 C1111.72386,41 1111.5,40.7761424 1111.5,40.5 C1111.5,40.2238576 1111.72386,40 1112,40 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-in-progress",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-to-reference/4",
    transform: "translate(-1104.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icn_info",
    fill: "#D6DCE8",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltipDefault);
export default __webpack_public_path__ + "static/media/info-tooltip-default.748e79bc4eadff6d191fa62d5dd04dcc.svg";
export { ForwardRef as ReactComponent };